import { motion, useMotionValue, useTransform } from "framer-motion";

function InteractiveCard({ title, description, delay = 0 }) {
  const pointerX = useMotionValue(0);
  const pointerY = useMotionValue(0);

  const rotateX = useTransform(pointerY, [0, 1], [8, -8]);
  const rotateY = useTransform(pointerX, [0, 1], [-8, 8]);

  const handleMouseMove = (event) => {
    const boundingRect = event.currentTarget.getBoundingClientRect();
    const relativeX = (event.clientX - boundingRect.left) / boundingRect.width;
    const relativeY = (event.clientY - boundingRect.top) / boundingRect.height;
    pointerX.set(relativeX);
    pointerY.set(relativeY);
  };

  const handleMouseLeave = () => {
    pointerX.set(0.5);
    pointerY.set(0.5);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, delay }}
      className="relative"
    >
      <motion.div
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{ rotateX, rotateY }}
        whileHover={{ scale: 1.02 }}
        transition={{ type: "spring", stiffness: 300, damping: 22 }}
        className="group relative overflow-hidden p-6 rounded-2xl border border-emerald-900/10 bg-gradient-to-br from-white to-emerald-50/40 shadow-[0_6px_30px_-12px_rgba(16,185,129,0.25)]"
      >
        {/* Soft corner glows */}
        <div className="absolute -top-20 -left-20 w-64 h-64 rounded-full blur-3xl pointer-events-none bg-emerald-300/20" />
        <div className="absolute -right-24 -bottom-24 w-64 h-64 rounded-full blur-3xl pointer-events-none bg-emerald-200/10" />

        {/* Shine sweep */}
        <div className="absolute inset-0 opacity-0 transition-opacity duration-500 pointer-events-none group-hover:opacity-100">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-transparent transition-transform duration-700 -translate-x-full group-hover:translate-x-0 via-white/20" />
        </div>

        <div className="relative z-10">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-gray-600">{description}</p>
        </div>
      </motion.div>
    </motion.div>
  );
}

export default function WhoWeAre() {
  return (
    <section className="relative py-14 bg-gradient-to-b from-white via-white md:py-18 to-emerald-50/30">
      <div className="px-6 mx-auto max-w-6xl">
        <div className="text-center">
          <div className="inline-block relative">
            <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 md:text-3xl">
              Who we are
            </h2>
            <span className="absolute -bottom-1 left-1/2 w-11 h-2 rounded-full -translate-x-1/2 bg-emerald-300/80" />
          </div>
          <p className="mt-3 text-sm text-gray-600 md:text-base">
            Overview of TripSecure’s team, platform and capabilities
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 mt-8 md:mt-12 md:grid-cols-2">
          <InteractiveCard
            title="Mission"
            description="To connect financial service providers to underserved and digitally active customers using mobile-first infrastructure and intelligent targeting."
            delay={0.1}
          />
          <InteractiveCard
            title="Vision"
            description="To democratize access to financial services through inclusive digital distribution."
            delay={0.2}
          />
        </div>
      </div>
    </section>
  );
}


